import { Pagination, PaginationContent, PaginationItem, PaginationNext, PaginationPrevious } from '@/view/components/ui/pagination'

interface Props {
  total: number
  totalForPage: number
  page: number
  next: () => void
  back: () => void
  labelItem?: string
}

export function PaginationDemo({ back, next, total, totalForPage, page, labelItem = 'solicitações' }: Props) {
  const valueNow = totalForPage * (page + 1) > total ? total : totalForPage * (page + 1)
  return (
    <Pagination className='w-full flex justify-between items-center py-2 border-t text-gray-500 '>
      <div className='px-2 text-sm text-gray-500'>{`${valueNow} de ${total} ${labelItem}.`}</div>
      <PaginationContent>
        <PaginationItem className='cursor-pointer'>
          <PaginationPrevious onClick={back}></PaginationPrevious>
        </PaginationItem>
        <PaginationItem className='mx-2'>{(page + 1)}</PaginationItem>
        <PaginationItem className='cursor-pointer'>
          <PaginationNext onClick={next} />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  )
}
